import { allPaths } from '@/routing/paths';

interface Route {
  path: string;
}

type PathObject = { path: string };
type PathRecord = Record<string, unknown>;

function isPathObject(input: unknown): input is PathObject {
  return (
    typeof input === 'object' &&
    input !== null &&
    'path' in input &&
    typeof (input as Record<string, unknown>).path === 'string'
  );
}

function isPathRecord(input: unknown): input is PathRecord {
  return typeof input === 'object' && input !== null;
}

function routeFromString(path: string): Route {
  return { path };
}

function routeFromObject(obj: PathObject): Route {
  return { path: obj.path };
}

function toRoute(value: unknown): Route[] {
  if (typeof value === 'string') {
    return [routeFromString(value)];
  }

  if (isPathObject(value)) {
    return [routeFromObject(value)];
  }

  if (isPathRecord(value)) {
    return routesFromRecord(value);
  }

  return [];
}

function routesFromRecord(record: PathRecord): Route[] {
  return Object.values(record).flatMap(toRoute);
}

export const routes: Route[] = Object.values(allPaths).flatMap(toRoute);
